import { Component, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { FileCard} from "../../../../core/types/file-card.types";
import { defaultImgSize } from "./configs/file-card-config";
import { EditModeService } from "../../../../core/services/edit-mode.service";
import { ButtonAction } from "../../../../core/types/button-action.types";
import { FileCardService } from "./services/file-card.service";
import { FileCardActionStateService } from "./services/file-card-action-state.service";
import { smoothShowHideHeight } from "../../../animations/smoothShowHideAnimations";
import { ImgSize } from "./types/file-card.types";
import { CardVariantSecondComponent } from "./components/card-variant-second/card-variant-second.component";
import { CardVariantFirstComponent } from "./components/card-variant-first/card-variant-first.component";

@Component({
  selector: 'app-file-card',
  standalone: true,
  imports: [
    CardVariantSecondComponent,
    CardVariantFirstComponent

  ],
  templateUrl: './file-card.component.html',
  styleUrl: './file-card.component.scss',
  animations: [ smoothShowHideHeight ]
})
export class FileCardComponent implements OnInit, OnDestroy {
  fileCard = input.required<FileCard>();
  isNeedArrow = input<boolean>(false);
  isNeedPreview = input<boolean>(false);
  cardVariant = input<string>('first');
  imgSize = input<ImgSize>(defaultImgSize);
  handleDelete = output<boolean>();

  public fileCardActionStateService: FileCardActionStateService = inject(FileCardActionStateService);
  private editModeService: EditModeService = inject(EditModeService);
  private fileCardService: FileCardService = inject(FileCardService);

  public async ngOnInit(): Promise<void> {
    this.isNeedPreview() && await this.fileCardService.getPreviewFiles(this.fileCard().fileParams.id);
  }

  public ngOnDestroy(): void {
    this.editModeService.setEditMode(this.fileCard().isEditModeActive);
    this.fileCardActionStateService.resetActionState();
  }

  public isImage(fileCard: FileCard): boolean {
    return this.fileCardService.isImage(fileCard);
  }

  public getInfoTooltip(): string {
    return this.fileCardService.getInfoTooltip(this.fileCard().fileParams);
  }

  public async handleClick(buttonAction: ButtonAction): Promise<void> {
    const { fileParams } = this.fileCard();

    const actionMap: Record<ButtonAction, () => Promise<void>> = {
      download: () => this.fileCardService.downloadFile(fileParams, 'download'),
      open: () => this.fileCardService.handleOpenAction(this.fileCard(), this.isNeedArrow()),
      delete: () => this.deleteFile(this.fileCard())
    };

    await actionMap[buttonAction]?.();
  }

  public isAction(id: number): boolean {
    return this.fileCardActionStateService.isActionState() &&
      this.fileCardActionStateService.currentFIleIdState() === id;
  }

  private async deleteFile(fileCard: FileCard): Promise<void> {
    const isConfirmed = await this.fileCardService.getDeleteConfirmation();
    this.editModeService.setEditMode(this.fileCard().isEditModeActive);
    if (!isConfirmed) { return; }

    this.handleDelete.emit(this.isImage(fileCard));
  }
}
